class InfiniteScroll extends HTMLElement {
    constructor() {
        super();
        this.observer = null;
        this.loading = false;
    }

    connectedCallback() {
        this.grid = this.querySelector('.product-grid');
        this.paginationType = this.dataset.paginationType;
        this.nextUrl = this.dataset.nextUrl;

        if (!this.grid) {
            console.error('InfiniteScroll: Product grid not found', this);
            return;
        }

        // Force display block
        this.style.display = 'block';



        if (this.paginationType === 'infinite_scroll') {
            this.initInfiniteScroll();
        } else if (this.paginationType === 'click_to_load') {
            this.initClickToLoad();
        }
    }

    disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
    }

    initInfiniteScroll() {
        if (!this.nextUrl) return; // Don't init if no next page


        const options = {
            root: null,
            rootMargin: '0px 0px 400px 0px',
            threshold: 0
        };

        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

        // Create a button instead of a hidden sentinel
        const button = document.createElement('button');
        button.className = 'button button--primary infinite-scroll-button';
        button.innerText = 'Load More';
        button.style.marginTop = '20px';
        button.style.width = '100%'; // Optional: make it full width or match design

        // Allow manual click primarily, but observer will auto-trigger it
        button.addEventListener('click', () => {
            if (!this.loading && this.nextUrl) {
                this.loadNextPage();
            }
        });

        this.appendChild(button);
        this.button = button; // Store reference so loadNextPage can remove it
        this.observer.observe(button);
    }

    handleIntersect(entries) {
        const entry = entries[0];
        if (entry.isIntersecting && !this.loading && this.nextUrl) {
            this.loadNextPage();
        }
    }

    initClickToLoad() {
        if (!this.nextUrl) return; // Don't init if no next page

        const button = document.createElement('button');
        button.className = 'button button--primary infinite-scroll-button';
        button.innerText = 'Load More';
        button.addEventListener('click', () => {
            if (!this.loading && this.nextUrl) {
                this.loadNextPage();
            }
        });
        this.appendChild(button);
        this.button = button;
    }

    async loadNextPage() {
        this.loading = true;
        if (this.button) this.button.classList.add('loading');

        try {
            const url = new URL(this.nextUrl, window.location.origin);
            const sectionId = this.dataset.sectionId || 'main-collection-product-grid';
            url.searchParams.set('section_id', sectionId);

            const response = await fetch(url.toString());
            if (!response.ok) throw new Error('Network response was not ok');
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            // When fetching via section_id, Shopify returns the section HTML directly.
            // We look for the grid items within that response.
            // Sometimes it wraps it in a div with the section ID, sometimes just the content.
            // We'll search for the grid items generally.

            const newProducts = doc.querySelectorAll('#product-grid .grid__item');

            if (newProducts.length) {
                newProducts.forEach(product => {
                    this.grid.appendChild(product);
                });
            }

            // Update next URL
            // The pagination might be inside the returned HTML.
            const nextUrlElement = doc.querySelector('[data-next-url]');
            if (nextUrlElement) {
                this.nextUrl = nextUrlElement.dataset.nextUrl;
                this.dataset.nextUrl = this.nextUrl;
            } else {
                // Fallback: Check if there's a standard pagination link in the response
                const standardNextLink = doc.querySelector('.pagination__item--next');
                if (standardNextLink) {
                    this.nextUrl = standardNextLink.getAttribute('href');
                    this.dataset.nextUrl = this.nextUrl;
                } else {
                    this.nextUrl = null;
                }
            }

            if (!this.nextUrl) {
                this.dataset.nextUrl = '';
                if (this.observer) this.observer.disconnect();
                if (this.button) this.button.remove();
            }

        } catch (error) {
            console.error('Error loading next page:', error);
        } finally {
            this.loading = false;
            if (this.button) this.button.classList.remove('loading');
        }
    }
}

customElements.define('infinite-scroll', InfiniteScroll);
